import * as React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Theme } from '@mui/material/styles'

export type SidebarFooterProps = {
  onSave: () => void
  onCancel: () => void
  saveDisabled: boolean
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({
  onSave,
  onCancel,
  saveDisabled,
}) => (
  <Box display="flex" alignItems="center" px={1} py={2}>
    <Button
      onClick={onCancel}
      sx={{
        marginLeft: 'auto',
        marginRight: (theme: Theme) => theme.spacing(1),
      }}
      variant="outlined"
      color="primary"
    >
      Cancel
    </Button>
    <Button
      disabled={saveDisabled}
      onClick={onSave}
      variant="contained"
      color="primary"
      data-test-id="sidebarSaveBtn"
    >
      Save
    </Button>
  </Box>
)
SidebarFooter.displayName = 'SidebarFooter'
